/**
 * SGI Action Types
 */
// Session lifecycle
export const SET_SGI_SESSION = 'SET_SGI_SESSION';
export const CLEAR_SGI_SESSION = 'CLEAR_SGI_SESSION';
// State synchronization
export const SET_SGI_STATE = 'SET_SGI_STATE';
export const SGI_READY = 'SGI_READY';
// Legacy (kept for backward compatibility with container approach)
export const SET_SGI_LEGACY = 'SET_SGI_LEGACY';
